import { render, staticRenderFns } from "./Edit-Question.vue?vue&type=template&id=09a6ab25"
import script from "./Edit-Question.vue?vue&type=script&lang=js"
export * from "./Edit-Question.vue?vue&type=script&lang=js"
import style0 from "./Edit-Question.vue?vue&type=style&index=0&id=09a6ab25&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports